import React, { useState } from 'react'
import { router, usePage } from '@inertiajs/react'
import { IconX } from '@tabler/icons-react'
import { Button } from '@/components/ui/button'

export function DocumentationToggle() {
  const { props } = usePage()
  const isAuthenticated = props.auth?.isAuthenticated ?? false
  const canToggleDocumentation = props.auth?.canToggleDocumentation ?? false
  const [isVisible, setIsVisible] = useState(true)
  
  // Don't show toggle for:
  // 1. Non-authenticated users
  // 2. Users who can't toggle documentation (new users)
  // 3. If the banner was closed
  if (!isAuthenticated || !canToggleDocumentation || !isVisible) {
    return null
  }
  
  const handleToggle = () => {
    router.post('/account/toggle_documentation_preference')
  }

  return (
    <div className="bg-amber-50 dark:bg-amber-950/30">
      <div className="mx-auto px-4 py-2" style={{ maxWidth: '80%' }}>
        <div className="flex items-center justify-between">
          <span className="text-sm text-amber-800 dark:text-amber-200 font-medium">
            Still on the legacy uploader? Switch back to V1 docs
          </span>
          <div className="flex items-center gap-2">
            <Button 
              onClick={handleToggle}
              variant="outline"
              size="sm"
              className="text-amber-700 dark:text-amber-200 bg-white dark:bg-amber-900/50 border-amber-300 dark:border-amber-700 hover:bg-amber-100 dark:hover:bg-amber-900/70"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
              Switch
            </Button>
            <Button
              onClick={() => setIsVisible(false)}
              variant="ghost"
              size="icon"
              className="h-6 w-6 text-amber-600 dark:text-amber-400 hover:text-amber-800 dark:hover:text-amber-200"
              aria-label="Close banner"
            >
              <IconX className="w-4 h-4" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
